const KEY = "tt_token";
const SUPER_KEY = "tt_super_token";

export function getToken() {
  return localStorage.getItem(KEY) || sessionStorage.getItem(KEY);
}

export function setToken(token, remember) {
  localStorage.removeItem(KEY);
  sessionStorage.removeItem(KEY);
  (remember ? localStorage : sessionStorage).setItem(KEY, token);
}

export function clearToken() {
  localStorage.removeItem(KEY);
  sessionStorage.removeItem(KEY);
  sessionStorage.removeItem(SUPER_KEY);
}

export function enterImpersonationToken(token) {
  const current = getToken() || "";
  sessionStorage.setItem(SUPER_KEY, current);
  localStorage.removeItem(KEY);
  sessionStorage.setItem(KEY, token);
}

export function exitImpersonationToken() {
  const superTok = sessionStorage.getItem(SUPER_KEY) || "";
  sessionStorage.removeItem(SUPER_KEY);
  localStorage.removeItem(KEY);
  sessionStorage.removeItem(KEY);
  if (superTok) localStorage.setItem(KEY, superTok);
  return superTok;
}

export function isImpersonating() {
  return !!sessionStorage.getItem(SUPER_KEY);
}
